package com.klantenstop.web.data.models.dto.responses

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CategoryDto(
    val id: String = "",
    val slug: String = "",
    val name: String = "",
    @SerialName("alt_text")
    val altText: String? = null,
    val highlighted: Boolean = false,
    val description: String = "",
    val logo: MediaFileDto? = null,
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = "",
)
